<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon
               v-bind="attrs"
               v-on="on"
               @click="dialog = true"
        >
          <v-icon>mdi-file-music-outline</v-icon>
        </v-btn>
      </template>
      <span>Audio file paths configuration</span>
    </v-tooltip>

    <v-dialog 
      v-model = "dialog"
      width   = "500"
    >
      <v-card>
        <v-card-title>Audio paths configuration</v-card-title>
        <v-card-text>
          <AudioPathsForm></AudioPathsForm>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="!isVideoLoading"
                 @click="dialog = false"
                 text
          > Cancel</v-btn>
          <v-btn color="primary"
                 text
                 @click="loadAudio"
          >
            <span v-if="isVideoLoading">
              <v-progress-circular indeterminate
                                   color="primary"
                                   :size="24"
              ></v-progress-circular>
            </span>
            <span v-if="!isVideoLoading">Load audio</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AudioPathsForm from '@/components/file-explorer/folder-controls/AudioPathsForm';
import { BusService } from '@/services/bus.service';

export default {
  name:       'AudioPathConfig',
  components: { AudioPathsForm },
  data:       function () {
    return {
      dialog:         false,
      isVideoLoading: false,
    };
  },
  mounted() {
    BusService.videoLoaded.subscribe(() => {
      this.isVideoLoading = false;
    });
  },
  methods: {
    loadAudio() {
      this.isVideoLoading = true;
      this.$emit('load-audio');
    },
  },
};
</script>

<style scoped></style>
